
// custom open size show
function customLwpHandleShowSize(e) {
  if (e?.target?.nextElementSibling) {
    var content = e.target.nextElementSibling;
    content.classList.toggle("visible");
    e.target.classList.toggle("hidden");
  }
}

// Function to add to cart
function simpleCustomAddToCart(formData, openCartDrawer = false) {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      if (openCartDrawer) {
        const drawer = document.querySelector("cart-drawer");
        if (drawer) {
          drawer.show();
          setTimeout(() => {
            customLwpHandleShowSize()
          }, 100);
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// function to handle Add to Cart
function customLwpAddToCart(e) {
  let openCartDrawer = false;
  const addToCard = e.target;
  const parent = e.target.parentNode;
  if (parent) {
    const previous = parent.previousElementSibling;
    if (previous && previous.classList.contains("hidden")) {
      previous.classList.toggle("hidden");
      parent.classList.toggle("visible");
    }
  }
  const variantId = addToCard?.dataset?.variantId;
  const productHandle = addToCard?.dataset?.productHandle || false;
  const data = addToCard.dataset;
  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  if (data.customNote && String(data.customNote).toLowerCase() === "true") {
    const cartNoteWrapper = e.target.closest(".cart_note-accordion.accordion");
    if (cartNoteWrapper) {
      const cartNoteValue = cartNoteWrapper.querySelector('[name="visibleNote"]');
      if (cartNoteValue) {
        formData.items.forEach((item) => {
          item.properties = { note: cartNoteValue.value };
        });
      }
    }
  }
  if (data.openCartDrawer && String(data.openCartDrawer).toLowerCase() === "true") {
    openCartDrawer = true;
  }
  simpleCustomAddToCart(formData, openCartDrawer);

  console.log("Adding to cart", e);
  document.documentElement.dispatchEvent(
    new CustomEvent("customAddToCart", {
      bubbles: true,
      detail: { id: variantId, handle: productHandle, quantity: 1 },
    })
  );
};

// Function to Save Cart update.js
function saveNoteCart(formData) {
  const cartUpdate = { ...formData };

  // If we have attributes, add them to the cart update
  if (formData.attributes) {
    cartUpdate.attributes = formData.attributes;
  }

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cartUpdate),
  }).then((response) => {
    console.log("Cart updated successfully");
  }).catch((error) => {
    console.error("Error:", error);
  });
}

// Function to Save Cart onclick
function cartSaveNoteButton(e) {
  const cartNoteWrapper = e.target.closest(".cart_note-accordion.accordion");
  if (cartNoteWrapper) {
    const accordionToogle = cartNoteWrapper.querySelector(".save_note-accordion");
    if (accordionToogle) {
      accordionToogle.click();

      // Get the note value
      let cartNoteValue = cartNoteWrapper.querySelector('[name="visibleNote"]');
      const noteValue = cartNoteValue ? cartNoteValue.value : '';

      // Get the selected occasion (if any)
      let selectedOccasion = cartNoteWrapper.querySelector('input[name="occasion"][checked]');
      const occasionValue = selectedOccasion ? selectedOccasion.value : '';

      // Create the cart update object with note and attributes
      const cartUpdate = {
        note: noteValue,
        attributes: {
          "Gift Occasion": occasionValue
        }
      };

      // Save the cart with both note and occasion attribute
      saveNoteCart(cartUpdate);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof yotpo !== "undefined") {
    yotpo.refreshWidgets();
  }
  if (typeof window?.yotpoWidgetsContainer !== "undefined" && typeof window?.yotpoWidgetsContainer?.initWidgets !== "undefined") {
    window.yotpoWidgetsContainer.initWidgets();
  }
});

document.addEventListener("cart:refreshed", () => {
  if (typeof yotpo !== "undefined") {
    yotpo.refreshWidgets();
  }
  if (typeof window?.yotpoWidgetsContainer !== "undefined" && typeof window?.yotpoWidgetsContainer?.initWidgets !== "undefined") {
    window.yotpoWidgetsContainer.initWidgets();
  }
});

